import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled, { css } from 'styled-components';
// eslint-disable-next-line complexity
const commonModalContainerContainerStyled = (mediaQuery, minWidth, minHeight, maxWidth, maxHeight, hasFooter = false) => mediaQuery &&
    css `
    ${mediaQuery} {
      ${minWidth &&
        css `
        min-width: ${minWidth};
      `}
      ${minHeight &&
        css `
        min-height: ${minHeight};
      `};
      ${maxWidth &&
        css `
        max-width: ${maxWidth || '100vw'};
      `}
      ${maxHeight &&
        css `
        max-height: ${maxHeight || '100vh'};
      `}
      padding-bottom: ${hasFooter ? '0' : null};
    }
  `;
export const ModalContainerStyled = styled.div `
  ${props => getStyles(props.$styles.container)};
  ${({ hasFooter, $minHeight, $minWidth, $maxHeight, $maxWidth, theme: { MEDIA_QUERIES: { onlyTablet, onlyDesktop, onlyMobile }, }, }) => css `
    ${commonModalContainerContainerStyled(onlyDesktop, $minWidth, $minHeight, $maxWidth, $maxHeight, hasFooter)}
    ${commonModalContainerContainerStyled(onlyTablet, $minWidth, $minHeight, $maxWidth, $maxHeight, hasFooter)}
    ${commonModalContainerContainerStyled(onlyMobile, $minWidth, $minHeight, $maxWidth, $maxHeight, hasFooter)}
  `}
`;
export const ModalContainerActionAndHeaderStyled = styled.div `
  ${props => getStyles(props.$styles.actionsAndHeaderContainer)}
`;
export const ModalContainerActionsStyled = styled.div `
  ${props => getStyles(props.$styles.actionsContainer)};
`;
export const ModalContainerHeaderStyled = styled.div `
  ${props => getStyles(props.$styles.headerContainer)};
`;
export const ModalContainerTitleStyled = styled.div `
  ${props => getStyles(props.$styles.titleContainer)}
`;
export const ModalContainerContentStyled = styled.div `
  word-break: break-word;
  line-height: 1.5rem;
  ${props => getStyles(props.$styles.content)}
  min-height: ${({ $minContentHeight }) => $minContentHeight};
`;
export const ModalContainerFooterStyled = styled.div `
  ${props => getStyles(props.$styles.footer)}
`;
export const ModalContainerDraggableIconStyled = styled.div `
  ${props => getStyles(props.$styles?.draggableIconContainer)}
`;
export const DraggableIcon = styled.div `
  ${props => getStyles(props.$styles?.dragIconContainer)}
`;
//# sourceMappingURL=modalContainer.styled.js.map